// extracted by mini-css-extract-plugin
module.exports = {"root":"b554178074371e8b1c4230e430c34326"};